import { SupportIcon } from '@heroicons/vue/outline'

export default [
    {
        path: '/help',
        link: 'https://flowfuse.com/docs',
        external: true,
        profileLink: true,
        profileMenuIndex: 60,
        name: 'Documentation',
        icon: SupportIcon
    }
]
